import * as React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'redux/rootReducer';
import { ThunkDispatch } from 'redux-thunk';
import { CreateLabel, LabelActions } from 'redux/ducks/data/labels';
import LabelTable from 'pages/Settings/components/settings/registrations/components/labelTable/LabelTable';
import * as labelActions from 'redux/ducks/data/labels';
import { IPatchObject } from 'redux/ducks/data/registrations';

type StoreProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type ComponentProps = DispatchProps & StoreProps;

const LabelsContainer: React.FunctionComponent<ComponentProps> = (props) => {
  const { labels, fetchLabels, updateLabel, deleteLabel, createLabel } = props;

  useEffect(() => {
    void fetchLabels();
  }, []);

  function handleDelete(labelId: string) {
    void deleteLabel(labelId);
  }

  function handleCreate(label: CreateLabel) {
    void createLabel(label);
  }

  function handleUpdate(labelId: string, patch: IPatchObject[]) {
    void updateLabel(labelId, patch);
  }

  return (
    <LabelTable
      labels={labels}
      onDelete={handleDelete}
      onCreate={handleCreate}
      onUpdate={handleUpdate}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  labels: state.data.labels.labels,
  loading: state.data.labels.loading
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, void, LabelActions>) => ({
  fetchLabels: () => dispatch(labelActions.getLabels()),
  deleteLabel: (id: string) => dispatch(labelActions.deleteLabel(id)),
  createLabel: (label: CreateLabel) => dispatch(labelActions.createLabel(label)),
  updateLabel: (labelId: string, patch: IPatchObject[]) =>
    dispatch(labelActions.updateLabel(labelId, patch))
});

export default connect<StoreProps, DispatchProps, unknown>(
  mapStateToProps,
  mapDispatchToProps
)(LabelsContainer);
